<app-subsection-title key="provider.tender.projectDescription.title" />

<div class="card bg-third-level">
  @if (formattedCharterContentResource.isLoading()) {
    <app-loading />
  } @else {
    @if (tenderDetails().beginningText) {
      <div [innerHTML]="tenderDetails().beginningText"></div>
    }

    @if (formattedCharterContent()) {
      <br />
      <div [innerHTML]="formattedCharterContent()"></div>
    }

    @if (tenderDetails().endText) {
      <br />
      <div [innerHTML]="tenderDetails().endText"></div>
    }

    @if (!tenderDetails().beginningText && !formattedCharterContent() && !tenderDetails().endText) {
      <p class="text-sm">
        {{ 'provider.tender.projectDescription.noData' | transloco }}
      </p>
    }
  }
</div>
